import { Stack } from '@mui/material'
import ScrollContainer from 'components/page/ScrollContainer'
import { heightOfToolbar } from 'const'
import React from 'react'
import { TimelineTeamControlAdd } from '../TimelineTeamControlAdd/TimelineTeamControlAdd'
import { TimelineTeamControlSelect } from '../TimelineTeamControlSelect/TimelineTeamControlSelect'
import { TimelineTeamMemberControlAdd } from '../TimelineTeamMemberControlAdd/TimelineTeamMemberControlAdd'
import { TimelineTeamMembers } from '../TimelineTeamMembers/TimelineTeamMembers'
import * as Styled from './TimelineTraineeMembersTab.styled'

export function TimelineTraineeMembersTab() {
  return (
    <Stack paddingLeft={{ xs: 2 }} paddingRight={1} spacing={2}>
      <Stack direction="row" justifyContent="flex-end" mt={2} mr={2} mb={1}>
        <TimelineTeamControlAdd />
      </Stack>
      <Styled.TeamControlsContainer>
        <TimelineTeamControlSelect />
        <TimelineTeamMemberControlAdd />
      </Styled.TeamControlsContainer>

      <ScrollContainer deltaSpace={heightOfToolbar} hasPaddingRight={false}>
        <TimelineTeamMembers />
      </ScrollContainer>
    </Stack>
  )
}
